import React from 'react';
import { AssetTypes as assetTypes } from '../../utils/enums/AssetTypes';
import { getAssetUrl } from '../../utils/getAssetUrl';
import { showAssetInNewWindow } from './showAssetInNewWindow';

export interface IAsset {
    date: string | Date;
    type: string | assetTypes;
    size: number;
    name: string | null;
    id: string;
    filenameThumbnail?: undefined | string | null;
}

export function DocumentsGrid(props: {
    assets: IAsset[];
    objectId?: undefined | string;
    surveyId?: undefined | string;
    equipmentId?: undefined | string;
}) {
    const showAsset = (asset: IAsset) => {
        showAssetInNewWindow(asset, { objectId: props.objectId, surveyId: props.surveyId, equipmentId: props.equipmentId });
    };

    const downloadThumb = (assetId: string) => {
        if (props.equipmentId) {
            return `/api/equipmentAsset/${assetId}/download?thumb=true`;
        }
        return `/api/assets/${assetId}/download?thumb=true`;
    };

    const getAssetThumbnailUrl = (asset: IAsset) => {
        if (asset.type === assetTypes.MeasurementXLS) {
            return '/assets/img/excel_thmb.png';
        } else if (asset.type === assetTypes.ZipArchive || asset.type === assetTypes.TarArchive) {
            return '/assets/img/zip_thmb.png';
        } else if (asset.type === assetTypes.Document) {
            return '/assets/img/word_thmb.png';
        } else if (asset.type === assetTypes.BIM || asset.type === assetTypes['3DModel']) {
            return '/assets/img/3d_thmb.png';
        } else if (asset.type === assetTypes.AutoCad) {
            return '/assets/img/dwg_thmb.png';
        } else if (asset.type === assetTypes.Text) {
            return '/assets/img/txt_thmb.png';
        } else if (asset.type === assetTypes.Import) {
            return '/assets/img/csv_thmb.png';
        } else if (asset.type === assetTypes.MeasurementPDF) {
            if (asset.filenameThumbnail) {
                return downloadThumb(asset.id);
            }
            return '/assets/img/pdf_thmb.png';
        } else if (
            asset.type === assetTypes.Image ||
            asset.type === assetTypes.Image360 ||
            asset.type === assetTypes.ImageTif ||
            asset.type === assetTypes.ImageAnnotation
        ) {
            if (asset.filenameThumbnail) {
                return downloadThumb(asset.id);
            }
            return '/assets/img/image_thmb.png';
        } else if (asset.type === assetTypes.Unknown) {
            return '/assets/img/file_thmb.png';
        }
        return '/assets/img/file_thmb.png';
    };

    const showPopup = (assetType: assetTypes | string) => {
        if (
            assetType === assetTypes.MeasurementPDF ||
            assetType === assetTypes.Image ||
            assetType === assetTypes.Image360 ||
            assetType === assetTypes.ImageAnnotation
        ) {
            return true;
        }
        return false;
    };

    return (
        <>
            {props.assets &&
                props.assets.map((asset) => (
                    <div className="col-sm-6 col-md-3" key={asset.id}>
                        <div className="thumbnail">
                            {(showPopup(asset.type) && (
                                <a
                                    href={getAssetUrl(asset, { forceDownload: true, objectId: props.objectId, surveyId: props.surveyId })}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        showAsset(asset);
                                    }}
                                    className={`${asset.type}-report`}
                                >
                                    <img src={getAssetThumbnailUrl(asset)} height="120px" title={asset.name ?? ''} className="br-a" />
                                </a>
                            )) || (
                                <a href={getAssetUrl(asset, { forceDownload: true, objectId: props.objectId, surveyId: props.surveyId })}>
                                    <img src={getAssetThumbnailUrl(asset)} height="120px" title={asset.name ?? ''} className="br-a" />
                                </a>
                            )}
                            <div
                                className="caption fw600"
                                title={asset.name ?? ''}
                                style={{ minHeight: '70px', maxHeight: '70px', overflow: 'hidden', overflowX: 'hidden' }}
                            >
                                {asset.name}
                            </div>
                        </div>
                    </div>
                ))}
        </>
    );
}
